(function () {
      var controller = window.tcFreeShippingProgress || {
        initialized: false,
        fetchListenerReady: false,
        xhrListenerReady: false,
        lastCart: null,
        cartIsCanonical: false,
        pendingCartMutations: 0,
        mutationEpoch: 0,
        refreshInFlight: false,
        refreshTrailing: false,
        refreshTimer: null,
        refreshCallbacks: [],
        callbackRefreshAttempts: 0,
        quantityVerifications: {},
        pageHadBlur: false,
        pageWasHidden: false,
      };
      window.tcFreeShippingProgress = controller;

      controller.pendingCartMutations = Math.max(0, Number(controller.pendingCartMutations || 0));
      controller.mutationEpoch = Math.max(0, Number(controller.mutationEpoch || 0));
      controller.refreshCallbacks = Array.isArray(controller.refreshCallbacks)
        ? controller.refreshCallbacks
        : [];
      controller.callbackRefreshAttempts = Math.max(0, Number(controller.callbackRefreshAttempts || 0));
      controller.quantityVerifications = controller.quantityVerifications || {};
      if (typeof controller.refreshTimer === 'undefined') controller.refreshTimer = null;

      function formatRon(cents) {
        var amount = Math.max(0, cents) / 100;
        return amount.toLocaleString('ro-RO', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + ' lei';
      }

      function renderBar(bar, cart) {
        var threshold = Number(bar.dataset.thresholdCents || 0);
        var total = cart && typeof cart.total_price === 'number'
          ? cart.total_price
          : Number(bar.dataset.cartTotalCents || 0);
        var itemCount = cart && typeof cart.item_count === 'number'
          ? cart.item_count
          : Number(bar.dataset.cartItemCount || 0);
        var remaining = Math.max(0, threshold - total);
        var percent = threshold > 0 ? Math.min(100, Math.max(0, total / threshold * 100)) : 0;
        if (remaining > 0) percent = Math.min(99, percent);
        var updating = controller.pendingCartMutations > 0 || controller.progressUpdating === true;
        var message = bar.querySelector('[data-tc-free-shipping-message]');
        var reward = bar.querySelector('[data-tc-free-shipping-label]');
        var trackWrap = bar.querySelector('.tc-free-shipping-progress__track-wrap');
        var fill = bar.querySelector('[data-tc-free-shipping-fill]');

        bar.hidden = itemCount <= 0;
        bar.setAttribute('aria-busy', String(updating));
        bar.dataset.cartTotalCents = String(total);
        bar.dataset.cartItemCount = String(itemCount);
        bar.style.setProperty('--tc-free-shipping-progress', percent + '%');
        if (trackWrap) {
          trackWrap.style.setProperty('--tc-free-shipping-progress', percent + '%');
        }
        if (fill) {
          fill.style.setProperty('width', percent + '%', 'important');
          fill.style.minWidth = itemCount > 0 && percent > 0 ? '12px' : '0';
        }

        if (reward) reward.textContent = !updating && remaining === 0
          ? bar.dataset.rewardAchieved
          : bar.dataset.rewardGoal;
        if (!message) return;

        if (updating) {
          message.textContent = bar.dataset.updatingMessage;
          return;
        }

        if (remaining > 0) {
          message.innerHTML = 'Adaugă încă <strong>' + formatRon(remaining) + '</strong> și ai <strong>Transport Gratuit!</strong>';
        } else {
          message.innerHTML = '<strong>Ai obținut Transport Gratuit!</strong>';
        }
      }

      function updateAll(cart) {
        document.querySelectorAll('[data-tc-free-shipping-progress]').forEach(function (bar) {
          renderBar(bar, cart || controller.lastCart);
        });
      }

      function isProgressCart(cart) {
        return Boolean(
          cart &&
            typeof cart.total_price === 'number' &&
            typeof cart.item_count === 'number'
        );
      }

      function isLineCart(cart) {
        return isProgressCart(cart) && Array.isArray(cart.items);
      }

      function hasCanonicalLineCart() {
        return Boolean(controller.cartIsCanonical && isLineCart(controller.lastCart));
      }

      function acceptProgressCart(cart) {
        if (!isProgressCart(cart)) return false;

        // Mutation responses and events can arrive out of order. Only a fresh
        // cart read after all mutations settle can confirm the shipping reward.
        controller.cartIsCanonical = false;
        controller.progressUpdating = true;
        updateAll();
        return true;
      }

      function acceptCanonicalCart(cart) {
        if (!isLineCart(cart)) return false;

        controller.lastCart = cart;
        controller.cartIsCanonical = true;
        controller.progressUpdating = false;
        updateAll(cart);
        return true;
      }

      function resolveRefreshCallbacks(cart) {
        if (!isLineCart(cart) || !hasCanonicalLineCart()) return;

        var callbacks = controller.refreshCallbacks.splice(0);
        controller.callbackRefreshAttempts = 0;
        callbacks.forEach(function (entry) {
          try {
            entry.callback(cart);
          } catch (error) {}
        });
      }

      function expireRefreshCallbacks() {
        var callbacks = controller.refreshCallbacks.splice(0);
        controller.callbackRefreshAttempts = 0;
        callbacks.forEach(function (entry) {
          if (typeof entry.expire !== 'function') return;
          try {
            entry.expire();
          } catch (error) {}
        });
      }

      function cancelScheduledRefresh() {
        if (controller.refreshTimer === null) return;
        window.clearTimeout(controller.refreshTimer);
        controller.refreshTimer = null;
      }

      function runCartRefresh() {
        controller.refreshTimer = null;

        if (!window.fetch) return;
        if (controller.pendingCartMutations > 0) {
          controller.refreshTrailing = true;
          return;
        }
        if (controller.refreshInFlight) {
          controller.refreshTrailing = true;
          return;
        }

        controller.refreshInFlight = true;
        var refreshEpoch = controller.mutationEpoch;
        var acceptedCart = null;
        var refreshFailed = false;

        window.fetch('/cart.js', {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart request failed');
            return response.json();
          })
          .then(function (cart) {
            if (
              controller.pendingCartMutations !== 0 ||
              controller.mutationEpoch !== refreshEpoch
            ) {
              return;
            }

            if (acceptCanonicalCart(cart)) {
              acceptedCart = cart;
            } else {
              acceptProgressCart(cart);
              refreshFailed = true;
            }
          })
          .catch(function () {
            refreshFailed = true;
          })
          .then(function () {
            controller.refreshInFlight = false;

            if (acceptedCart) {
              resolveRefreshCallbacks(acceptedCart);
            } else if (
              refreshFailed &&
              controller.pendingCartMutations === 0 &&
              controller.mutationEpoch === refreshEpoch &&
              controller.refreshCallbacks.length > 0
            ) {
              controller.callbackRefreshAttempts += 1;
              if (controller.callbackRefreshAttempts >= 2) {
                expireRefreshCallbacks();
              } else {
                controller.refreshTrailing = true;
              }
            }

            if (controller.pendingCartMutations === 0 && controller.refreshTrailing) {
              controller.refreshTrailing = false;
              scheduleFetchCart();
            }
          });
      }

      function scheduleFetchCart(callback, expire) {
        var callbackQueued = typeof callback === 'function';
        if (callbackQueued) {
          if (controller.refreshCallbacks.length === 0) {
            controller.callbackRefreshAttempts = 0;
          }
          controller.refreshCallbacks.push({ callback: callback, expire: expire });
        }

        if (!window.fetch || controller.pendingCartMutations > 0) return;
        if (controller.refreshInFlight) {
          if (!callbackQueued) controller.refreshTrailing = true;
          return;
        }
        if (controller.refreshTimer !== null) return;

        controller.refreshTimer = window.setTimeout(runCartRefresh, 0);
      }

      controller.fetchCart = scheduleFetchCart;
      controller.updateAll = updateAll;

      function getCartFromEvent(event) {
        var detail = event && event.detail;
        var candidates = detail
          ? [detail.resource, detail.cart, detail.data, detail.response, detail]
          : [];

        for (var index = 0; index < candidates.length; index += 1) {
          if (isProgressCart(candidates[index])) return candidates[index];
        }
        return null;
      }

      function isCartMutationUrl(url) {
        return (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        );
      }

      function beginCartMutation() {
        controller.pendingCartMutations += 1;
        controller.mutationEpoch += 1;
        controller.cartIsCanonical = false;
        controller.progressUpdating = true;
        updateAll();
        cancelScheduledRefresh();

        if (controller.refreshInFlight) {
          controller.refreshTrailing = true;
        }

        return { settled: false };
      }

      function finishCartMutation(mutation, cart) {
        if (!mutation || mutation.settled) return;

        mutation.settled = true;
        controller.pendingCartMutations = Math.max(0, controller.pendingCartMutations - 1);

        if (controller.pendingCartMutations > 0) return;

        if (controller.refreshInFlight) {
          controller.refreshTrailing = true;
        } else {
          controller.refreshTrailing = false;
          scheduleFetchCart();
        }
      }

      function dispatchCartRefresh(cart) {
        try {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                cart: cart,
                data: {},
              },
            })
          );
        } catch (error) {}
      }

      function isCartControl(target) {
        if (!(target instanceof Element)) return false;

        return Boolean(
          target.closest(
            'cart-drawer, cart-items, .cart-drawer, .cart, .cart__items, .cart-items, [id*="Cart"], [class*="cart"]'
          ) ||
            target.matches(
              'input[name="updates[]"], input[name="quantity"], quantity-selector input, cart-quantity-selector input'
            )
        );
      }

      function getCartQuantityInput(target) {
        if (!(target instanceof Element)) return null;

        var quantitySelector =
          target.closest('cart-quantity-selector-component') ||
          target.closest('quantity-selector-component') ||
          target.closest('.quantity-selector-wrapper') ||
          target.closest('[data-cart-line]');
        if (!quantitySelector || !quantitySelector.closest('cart-items-component')) return null;

        if (quantitySelector.matches('input[name="updates[]"][data-cart-line]')) {
          return quantitySelector;
        }
        return quantitySelector.querySelector('input[name="updates[]"][data-cart-line]');
      }

      function forceCartQuantity(line, quantity) {
        if (!window.fetch) return;

        window.fetch('/cart/change.js', {
          method: 'POST',
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ line: line, quantity: quantity }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart quantity fallback failed');
            return response.json();
          })
          .then(dispatchCartRefresh)
          .catch(function () {});
      }

      function verifyCartQuantity(line, quantity, version) {
        if (!window.fetch || !line) return;

        function isCurrent() {
          var current = controller.quantityVerifications[line];
          return Boolean(current && current.version === version && current.quantity === quantity);
        }

        function expire() {
          if (isCurrent()) delete controller.quantityVerifications[line];
        }

        function verify(cart) {
          if (!isCurrent() || !isLineCart(cart)) return;

          var item = cart.items[line - 1];
          var actualQuantity = item && typeof item.quantity === 'number' ? item.quantity : 0;
          delete controller.quantityVerifications[line];
          if (actualQuantity !== quantity) forceCartQuantity(line, quantity);
        }

        if (hasCanonicalLineCart()) {
          verify(controller.lastCart);
          return;
        }

        scheduleFetchCart(verify, expire);
      }

      function scheduleQuantityVerification(line, quantity) {
        if (!line || !isFinite(quantity) || quantity < 0) return;

        var previous = controller.quantityVerifications[line];
        if (previous && previous.timer !== null) window.clearTimeout(previous.timer);

        var version = previous ? previous.version + 1 : 1;
        var verification = {
          quantity: quantity,
          version: version,
          timer: null,
        };
        controller.quantityVerifications[line] = verification;
        verification.timer = window.setTimeout(function () {
          if (controller.quantityVerifications[line] !== verification) return;
          verification.timer = null;
          verifyCartQuantity(line, quantity, version);
        }, 1000);
      }

      function scheduleCartQuantityFallback(target) {
        var input = getCartQuantityInput(target);
        if (!input) return;

        var cartItems = input.closest('cart-items-component');
        var line = Number(input.dataset.cartLine || 0);
        if (!cartItems || !line) return;

        scheduleQuantityVerification(line, Number(input.value || 0));
      }

      function handleCartPayload(cart, refreshWhenMissing) {
        if (acceptProgressCart(cart) || refreshWhenMissing) scheduleFetchCart();
      }

      if (!controller.initialized) {
        controller.initialized = true;

        function handleCartEvent(event) {
          handleCartPayload(getCartFromEvent(event), true);
        }

        [
          'cart:update',
          'cart:change',
          'cart:refresh',
          'cart:updated',
          'cart-drawer:open',
          'cart-drawer:opened',
          'cart-drawer:refresh',
        ].forEach(function (eventName) {
          document.addEventListener(eventName, handleCartEvent);
        });

        document.addEventListener('quantity-selector:update', function (event) {
          handleCartPayload(getCartFromEvent(event), false);

          if (event.detail && event.detail.cartLine) {
            scheduleQuantityVerification(
              Number(event.detail.cartLine),
              Number(event.detail.quantity || 0)
            );
          } else {
            scheduleCartQuantityFallback(event.target);
          }
        }, true);

        document.addEventListener('click', function (event) {
          if (isCartControl(event.target)) scheduleCartQuantityFallback(event.target);
        }, true);

        ['input', 'change'].forEach(function (eventName) {
          document.addEventListener(eventName, function (event) {
            if (isCartControl(event.target)) scheduleCartQuantityFallback(event.target);
          }, true);
        });

        if (!controller.fetchListenerReady && window.fetch) {
          controller.fetchListenerReady = true;
          var originalFetch = window.fetch;

          window.fetch = function () {
            var request = arguments[0];
            var url = typeof request === 'string'
              ? request
              : request && request.url
                ? request.url
                : '';
            var mutation = isCartMutationUrl(url) ? beginCartMutation() : null;
            var promise;

            try {
              promise = originalFetch.apply(this, arguments);
            } catch (error) {
              finishCartMutation(mutation, null);
              throw error;
            }

            return promise.then(function (response) {
              if (!mutation) return response;
              if (!response || !response.ok) {
                finishCartMutation(mutation, null);
                return response;
              }

              try {
                response.clone().json().then(function (cart) {
                  finishCartMutation(mutation, cart);
                }).catch(function () {
                  finishCartMutation(mutation, null);
                });
              } catch (error) {
                finishCartMutation(mutation, null);
              }
              return response;
            }, function (error) {
              finishCartMutation(mutation, null);
              throw error;
            });
          };
        }

        if (!controller.xhrListenerReady && window.XMLHttpRequest) {
          controller.xhrListenerReady = true;
          var originalOpen = window.XMLHttpRequest.prototype.open;
          var originalSend = window.XMLHttpRequest.prototype.send;

          window.XMLHttpRequest.prototype.open = function (method, url) {
            this.tcFreeShippingProgressUrl = typeof url === 'string' ? url : '';
            return originalOpen.apply(this, arguments);
          };

          window.XMLHttpRequest.prototype.send = function () {
            var xhr = this;
            var mutation = isCartMutationUrl(xhr.tcFreeShippingProgressUrl || '')
              ? beginCartMutation()
              : null;

            if (mutation) {
              xhr.addEventListener('loadend', function () {
                var cart = null;
                try {
                  if (xhr.status >= 200 && xhr.status < 400) {
                    cart = xhr.responseType === 'json'
                      ? xhr.response
                      : JSON.parse(xhr.responseText || 'null');
                  }
                } catch (error) {}
                finishCartMutation(mutation, cart);
              });
            }

            try {
              return originalSend.apply(this, arguments);
            } catch (error) {
              finishCartMutation(mutation, null);
              throw error;
            }
          };
        }

        document.addEventListener('shopify:section:load', function () {
          updateAll(controller.lastCart);
          scheduleFetchCart();
        });

        new MutationObserver(function (records) {
          var hasNewBar = records.some(function (record) {
            return Array.prototype.some.call(record.addedNodes, function (node) {
              return node instanceof Element && (
                node.matches('[data-tc-free-shipping-progress]') ||
                node.querySelector('[data-tc-free-shipping-progress]')
              );
            });
          });
          if (hasNewBar) {
            updateAll();
            scheduleFetchCart();
          }
        }).observe(document.documentElement, { childList: true, subtree: true });

        window.addEventListener('pageshow', function (event) {
          if (!event || event.persisted !== true) return;
          controller.pageHadBlur = false;
          controller.pageWasHidden = false;
          controller.cartIsCanonical = false;
          controller.progressUpdating = true;
          updateAll();
          scheduleFetchCart();
        });
        window.addEventListener('blur', function () {
          controller.pageHadBlur = true;
        });
        window.addEventListener('focus', function () {
          if (!controller.pageHadBlur && !controller.pageWasHidden) return;
          controller.pageHadBlur = false;
          controller.pageWasHidden = false;
          scheduleFetchCart();
        });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            controller.pageWasHidden = true;
          } else if (controller.pageWasHidden) {
            controller.pageHadBlur = false;
            controller.pageWasHidden = false;
            scheduleFetchCart();
          }
        });

        scheduleFetchCart();
      }

      updateAll();
    })();
